import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import Button from "../../components/shared/button/component";
import FacebookLogin from "react-facebook-login";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { getFacebookClientId } from "../../utils/general-config";
const LegalSimpliSignUp = ({
  onSignUp,
  navigateSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  emailError,
  errorCount,
  emailErrorMsg,
  passwordError,
  passwordErrorMsg,
  loginError,
  loginErrorMessage,
  onEmailChangeHandler,
  onPwdChangeHandler,
  onPasswordKeyPress,
  emailId,
  pwd,
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_up.ls.description_meta")} />
        <title>{t("page_title.ls.sign_up")}</title>
      </Helmet>
      <section className="main-content">
        <div className="container mx-auto"></div>
        <div className="form-wrap"></div>
        <hgroup className="text-center user-page">
          <h1
            className="main-headline  text-[#424a5b] font-poppins text-3xl font-bold md:font-extrabold lg:font-extrabold mt-0 pb-2"
            style={{ fontFamily: '"Rubik", sans-serif' }}
          >
            {t("sign_up.ls.headline")}
          </h1>
          <h6 className="sub-headline text-[#424a5b] !text-xl font-bold mb-1">{t("sign_up.ls.sub_headline")}</h6>
        </hgroup>
        <div className="social-login ">
          <div className="social-login--google">
            <button type="button" id="googleBtn" className="google-login-button text-white" onClick={googleLogin}>
              <div className="bg-white m-px rounded-sm">
                <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} height="20px" width="20px" />
              </div>
              <span>{t("sign_up.continue_with_google")}</span>
            </button>
          </div>
          <div className="social-login--facebook">
            <FacebookLogin
              appId={getFacebookClientId()}
              autoLoad={false}
              fields="name,email"
              textButton={t("sign_up.continue_with_fb")}
              callback={responseFacebook}
              icon={
                <img
                  src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                  className="facebook-login-button"
                  id="fbBtn"
                />
              }
            />
          </div>
        </div>
        <div className="or-container !my-0">
          <span></span> {t("sign_up.or")} <span></span>
        </div>
        <div className="form-container">
          <div className="form-group">
            <div className="form-text mb-2">
              {emailError && (
                <p
                  key="pswrdErr"
                  role={alert}
                  className="alert error signup-error-message border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 py-1"
                >
                  <h2> {errorCount + t("sign_up.signup_alert_text")}</h2>
                  <br />
                  {emailError && (
                    <li>
                      <small key="pswrdErr">{emailErrorMsg}</small>
                    </li>
                  )}

                  {passwordError && (
                    <li>
                      <small key="pswrdErrw">{passwordErrorMsg}</small>
                    </li>
                  )}

                  {loginError && (
                    <li>
                      <small key="pswrdErrww">{loginErrorMessage}</small>
                    </li>
                  )}
                </p>
              )}
            </div>
            <InputText
              showLabel={false}
              id="email"
              text="Email Address"
              onChange={onEmailChangeHandler}
              value={emailId.trim()}
              maxLength={100}
              className="border-gray-300 rounded  p-2 border mb-3 max-w-96"
              placeholder={t("sign_up.ls.placeholder_email")}
            />
          </div>
          <div className="form-text">
            {emailError && (
              <small key="pswrdErr" className="text-red-500 font-sm">
                {emailErrorMsg}
              </small>
            )}
          </div>
          <div className="form-group">
            <InputText
              showLabel={false}
              id="password"
              text="Password"
              type="password"
              className="border-gray-300 rounded  p-2 border mb-3 max-w-96"
              onChange={onPwdChangeHandler}
              value={pwd}
              onKeyPress={onPasswordKeyPress}
              placeholder={t("sign_up.ls.placeholder_password")}
            />
          </div>
          <div className="form-text">
            {passwordError && (
              <small key="pswrdErr" className="text-red-500 font-sm">
                {passwordErrorMsg}
              </small>
            )}
          </div>

          <div className="form-text">
            {loginError && (
              <small key="pswrdErr" className="text-red-500 font-sm">
                {loginErrorMessage}
              </small>
            )}
          </div>
          <span className="from_bottom text-sm">
            {t("sign_up.ls.by_continuing")}{" "}
            <a href="" target="_blank" className="setCulture text-blue-600 hover:text-[#0B58C9]">
              {t("sign_up.ls.term_of_use")}
            </a>{" "}
            {t("sign_up.ls.and")}{" "}
            <a href="" target="_blank" className="setCulture text-blue-600 hover:text-[#0B58C9]">
              {t("sign_up.ls.privacy_policy")}
            </a>
            .
          </span>
          <div className=" fbn bounce-effect fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-0 lg:p-0 text-center w-full md:w-auto lg:w-auto z-50">
            <button
              className="theme_btn alante bg-[#f9593a] uppercase text-white py-3 px-7 text-lg font-bold rounded hover:bg-[#424a5b] w-full"
              isLoading={false}
              disabled={disableBtn}
              onClick={onSignUp}
            >
              {t("sign_up.ls.btn_cta")}
            </button>
          </div>
          <p className="mt-3 text-center text-[#424a5c]">
            <span
              dangerouslySetInnerHTML={{
                __html: sanitizer(t("sign_up.already_account")),
              }}
            />{" "}
            -{" "}
            <button
              className="setCulture d-inline-block text-[#0f67cb] hover:text-[#f9593a] font-bold "
              runat="server"
              id="alreadyHaveAnAccount"
              isLoading={false}
              disabled={disableBtn}
              onClick={navigateSignIn}
            >
              <i>
                <FontAwesomeIcon icon={faUser} className="text-center" />
              </i>{" "}
              {t("sign_up.ls.member_login")}
            </button>
          </p>
        </div>
      </section>
    </>
  );
};
export default LegalSimpliSignUp;
